import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../../context/LangContext';
import { useSession } from '../../context/SessionContext';

function Row({ icon, label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full flex items-center gap-3 px-4 py-3.5 rounded-xl hover:bg-brand-light/60 text-left"
    >
      <span className="text-lg w-6 text-center">{icon}</span>
      <span className="font-bold text-ink text-sm">{label}</span>
    </button>
  );
}

export default function SideMenu({ open, onClose, onSupportOpen }) {
  const { lang, toggle } = useLang();
  const { sessionUser, onLogout } = useSession();
  const navigate = useNavigate();
  const te = lang === 'te';

  if (!open) return null;

  const go = (path) => { onClose(); navigate(path); };

  return (
    <div className="fixed inset-0 z-[350] md:hidden" role="presentation">
      <div className="absolute inset-0 bg-ink/50 animate-fadeIn" onClick={onClose} />
      <div className="absolute inset-y-0 left-0 w-[82%] max-w-[320px] bg-white shadow-lift animate-slideOver flex flex-col">
        <div className="bg-gradient-to-br from-brand-dark to-brand px-5 pt-8 pb-5 text-white">
          <div className="h-12 w-12 rounded-full bg-white/20 flex items-center justify-center font-black text-lg mb-3">
            {(sessionUser?.name || '?').slice(0, 1).toUpperCase()}
          </div>
          <div className="font-black text-[15px] truncate">{sessionUser?.name || (te ? 'అతిథి' : 'Guest')}</div>
          <div className="text-xs text-white/75 mt-0.5">{sessionUser?.phone || (te ? 'లాగిన్ అవ్వలేదు' : 'Not signed in')}</div>
        </div>

        <div className="flex-1 overflow-y-auto py-2 px-2">
          <Row icon="🏠" label={te ? 'హోమ్' : 'Home'} onClick={() => go('/')} />
          <Row icon="📂" label={te ? 'కేటగిరీలు' : 'Categories'} onClick={() => go('/categories')} />
          <Row icon="📦" label={te ? 'ఆర్డర్లు' : 'My Orders'} onClick={() => go('/orders')} />
          {sessionUser ? (
            <>
              <Row icon="👤" label={te ? 'ప్రొఫైల్' : 'Profile'} onClick={() => go('/profile')} />
              <Row icon="📍" label={te ? 'చిరునామాలు' : 'Addresses'} onClick={() => go('/profile/addresses')} />
              <Row icon="💰" label={te ? 'వాలెట్' : 'Wallet'} onClick={() => go('/profile/wallet')} />
            </>
          ) : (
            <Row icon="👤" label={te ? 'సైన్ ఇన్' : 'Sign in'} onClick={() => go('/signup')} />
          )}
          <div className="h-px bg-black/5 my-2 mx-3" />
          <Row icon={te ? '🇬🇧' : '🇮🇳'} label={te ? 'Switch to English' : 'తెలుగులోకి మార్చండి'} onClick={() => { toggle(); onClose(); }} />
          <Row icon="🆘" label={te ? 'సపోర్ట్' : 'Support'} onClick={() => { onClose(); onSupportOpen(); }} />
          <a
            href="/terms.html"
            target="_blank"
            rel="noreferrer"
            className="w-full flex items-center gap-3 px-4 py-3.5 rounded-xl hover:bg-brand-light/60 text-left"
          >
            <span className="text-lg w-6 text-center">📄</span>
            <span className="font-bold text-ink text-sm">{te ? 'నిబంధనలు' : 'Terms & Conditions'}</span>
          </a>
          <a
            href="/privacy.html"
            target="_blank"
            rel="noreferrer"
            className="w-full flex items-center gap-3 px-4 py-3.5 rounded-xl hover:bg-brand-light/60 text-left"
          >
            <span className="text-lg w-6 text-center">🔒</span>
            <span className="font-bold text-ink text-sm">{te ? 'గోప్యతా విధానం' : 'Privacy Policy'}</span>
          </a>
          {sessionUser ? (
            <Row icon="🚪" label={te ? 'సైన్ అవుట్' : 'Sign out'} onClick={() => { onLogout(); onClose(); navigate('/'); }} />
          ) : null}
        </div>

        <button
          type="button"
          onClick={onClose}
          className="m-3 py-3 rounded-xl bg-brand-light/70 text-brand-dark font-extrabold text-sm"
        >
          {te ? 'మూసివేయి' : 'Close'}
        </button>
      </div>
    </div>
  );
}
